import { render, staticRenderFns } from "./ShowCenter.vue?vue&type=template&id=afbde982&scoped=true&"
import script from "./ShowCenter.vue?vue&type=script&lang=js&"
export * from "./ShowCenter.vue?vue&type=script&lang=js&"
import style0 from "./ShowCenter.vue?vue&type=style&index=0&id=afbde982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbde982",
  null
  
)

export default component.exports